export const environment = {
	production: true,
	applicationServerPublicKey: `BEiovEqn3jrei827SLUWdvK9y005aTBynrndrIyNMlVIL2XdukxeBLflwLmXIjY3YqdY4fMakNdedNkw9LkTR0E`
};
